import { Link } from '@superhi/design'
import React from 'react'

const MARKETING_SITE_URL = 'www.superhi.com'

type Props = {
  url: string
}

const Hyperlink: React.FC<React.PropsWithChildren<Props>> = ({ url, children }) => {
  const isExternal = !url.includes(MARKETING_SITE_URL)
  const parsedUrl = isExternal ? url : url.split(MARKETING_SITE_URL)[1]

  return (
    <Link href={parsedUrl} isExternal={isExternal}>
      {children}
    </Link>
  )
}

export default Hyperlink
